import { Container, Row } from "reactstrap";
import { BasicCardTitle, BonusUi } from "../../../constants";
import BasicCard from "./BasicCard";
import DarkCard from "./DarkCard";
import FlatCard from "./FlatCard";
import HeadingIcon from "./HeadingIcon";
import InfoColorCard from "./InfoColorCard";
import WithoutShadow from "./WithoutShadow";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const BasicCardContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={BasicCardTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicCard />
          <FlatCard />
          <WithoutShadow />
          <HeadingIcon />
          <DarkCard />
          <InfoColorCard />
        </Row>
      </Container>
    </>
  );
};
export default BasicCardContainer;
